/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 5/3/17
 * Copyright All Rights Reserved
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Creates a Bootstrap .panel.default.panel
 * @param children
 * @constructor
 */
const Panel = props => (
  <div className={classNames('panel', 'panel-default', props.className)}>
    {props.children}
  </div>
);

Panel.defaultProps = {
  children: '',
  className: '',
};

Panel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default Panel;
